import * as S from './MealPlanAndRefundInfo.styles';

export default function MealPlanAndRefundInfo({mealPlanData, refundPlanData, paddingTop = null}) {
  return (
    <>
      <S.AmenitiesDetailsWrapper paddingTop={paddingTop}>
        {mealPlanData && mealPlanData?.t && (
          <S.MealsSpan color={mealPlanData?.tc}>{mealPlanData?.t}</S.MealsSpan>
        )}

        {mealPlanData && mealPlanData?.t && refundPlanData && refundPlanData?.t && (
          <S.DividerSpan></S.DividerSpan>
        )}

        {refundPlanData && refundPlanData?.t && (
          <S.RedAlertSpan color={refundPlanData?.tc}>{refundPlanData?.t}</S.RedAlertSpan>
        )}
      </S.AmenitiesDetailsWrapper>
    </>
  );
}
